const ModalDeletePuppyToSell = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-delete-puppy-to-sell"*/ "@/app/views/main-view/sell-your-dog/modals/delete-puppy-to-sell-modal/delete-puppy-to-sell-modal/delete-puppy-to-sell-modal.vue"
	)


// Constants
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';

export default {
    name: "SellPuppyList",
    components: {
		ModalDeletePuppyToSell,
	},
    props: {
        puppyList: {
            type: Array,
            required: true,
        },
        isAPILoading: {
            type: Boolean,
            default: false,
        },
        displayShowMoreButton: {
            type: Boolean,
            default: false,
        },
        
    },
    data() {
        return {
            puppyId: 0,
            SELL_YOUR_PUPPY_INFO: `${BREEDER_ROUTES.SELL_YOUR_PUPPY_INFO}`
        }
    },
    methods: {
        puppySellingStatus(status) {
            const statusMap = {
                ["AVAILABLE"]: "status--green",
                ["PICKED UP"]: "status--green",
                ["PENDING"]: "status--blue",
                ["REQUEST FOR REFUND"]: "status--blue",
                ["SOLD"]: "status--grey",
                ["REFUNDED"]: "status--grey",
                ["CANCELLED"]: "status--red",
                ["DECLINED"]: "status--red",
                ["HIDDEN"]: "status--red",
            };

            return statusMap[status] || "status--grey";
        },

        showEllipsis(status) {
			return status === "PENDING" || status === "AVAILABLE" || status === "HIDDEN"
		},

        deletePuppyToSell(puppy_id) {
            this.puppyId = parseInt(puppy_id)
			this.$refs.modalDeletePuppyToSell.openModal()
		},
        handlePuppyDeleted(puppySellId) {
            //pass back the deleted puppy id
            this.$emit('puppyListUpdated', puppySellId);
        },

        handleUpdatePuppyStatus(puppySellId, buyerId, status) {
            //pass back the deleted puppy id
            this.$emit('updatePuppySellStatus', puppySellId, buyerId, status);
        },

        puppyImage(image) {
            return image ? image : require("@/assets/images/_shared/dog-purchase.png");
        },

        showMore() {
            this.$emit("showMore");
        },
    },
};
